<div class="app-report-fault-dialog">
  <div class="header">
    <h3>Report a problem</h3>
    <button mat-icon-button class="close-button" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-divider></mat-divider>

  <ngx-simplebar [options]="{ autoHide: true }" style="max-height: 560px;">
    <div class="content">
      <app-alert [successMessage]="successMessage" [errorMessage]="errorMessage"></app-alert>

      <div class="fault-context" *ngIf="contextLabel">
        <mat-icon>info</mat-icon>
        <span>You're reporting <strong>{{ contextLabel }}</strong>.</span>
      </div>

      <form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
        <mat-form-field appearance="outline">
          <mat-label>What's wrong?</mat-label>
          <mat-select formControlName="faultType">
            <mat-option
              [value]="fault.key"
              *ngFor="let fault of FAULT_TYPES | keyvalue: keepOriginalOrder"
            >
              {{ fault.value }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Add any detail (optional)</mat-label>
          <textarea
            formControlName="description"
            matInput
            rows="5"
            placeholder="Type here..."
          ></textarea>
        </mat-form-field>

        <div class="photo-row">
          <button type="button" mat-stroked-button (click)="photoInput.click()">
            <mat-icon>photo_camera</mat-icon>
            {{ photoName() ? 'Change photo' : 'Add a photo (optional)' }}
          </button>
          <span class="photo-name" *ngIf="photoName()">{{ photoName() }}</span>
          <input
            #photoInput
            type="file"
            accept="image/*"
            hidden
            (change)="onPhotoSelected($event)"
          />
        </div>

        <div class="actions">
          <button
            [disabled]="isLoading() || formGroup.invalid"
            mat-flat-button
            type="submit"
          >
            Submit report
          </button>
        </div>
      </form>
    </div>
  </ngx-simplebar>
</div>
